import { useMediaQuery } from "@mui/material";
import { DynamicFormBuilderContainer } from "../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container";
import { FormItemTypes } from "../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import { MuiPopup } from "../../../../components";
import { red } from "../../../../theme/palette";
import { CancelDeleteIconSVG } from "../assets/customIcons";
import { t } from "i18next";
export var DiscardDocumentModal = function (props) {
    var openPopUp = props.openPopUp, handleCancelClick = props.handleCancelClick, handleDiscardClick = props.handleDiscardClick;
    var lgMode = useMediaQuery(function (theme) { return theme.breakpoints.up('sm'); });
    var formData = [{
            type: FormItemTypes.Custom,
            name: 'DeleteIcon',
            label: '',
            value: null,
            columnSize: 12,
            element: function () { /*#__PURE__*/ return React.createElement(CancelDeleteIconSVG, {
                sx: {
                    width: 48,
                    height: 48,
                    color: '#F5222D'
                },
                id: 'delete-icon'
            }); }
        }, {
            type: FormItemTypes.ContainerItem,
            name: 'DiscardText',
            label: '',
            value: null,
            columnSize: 12,
            spacing: 0,
            elements: [{
                    type: FormItemTypes.Typography,
                    name: 'Header',
                    label: "",
                    value: null,
                    children: "Are you sure you want to cancel?",
                    variant: 'h2',
                    flexDirection: "column",
                    columnGap: 0,
                    columnSize: 12,
                    labelTypographyProps: {
                        fontSize: '18px',
                        fontWeight: 600,
                        lineHeight: '28px',
                        color: '#1B1D21'
                    }
                }, {
                    type: FormItemTypes.Typography,
                    name: 'Header',
                    label: "",
                    value: null,
                    children: t("Selecting discard will discard your current form."),
                    fontSize: "14px",
                    color: "#8593A3",
                    flexDirection: "column",
                    columnGap: 0,
                    columnSize: 12
                }]
        }, {
            type: FormItemTypes.ContainerItem,
            name: 'buttonContainer',
            label: '',
            value: null,
            columnSize: 12,
            elements: [{
                    type: FormItemTypes.Button,
                    name: 'cancel',
                    label: '',
                    value: null,
                    columnSize: 6,
                    children: 'Cancel',
                    onClick: handleCancelClick,
                    variant: 'outlined',
                    sx: {
                        color: 'gray',
                        width: '100%'
                    }
                }, {
                    type: FormItemTypes.Button,
                    name: 'Discard',
                    label: '',
                    value: null,
                    children: 'Discard',
                    onClick: handleDiscardClick,
                    columnSize: 6,
                    sx: {
                        backgroundColor: red,
                        borderColor: "#DEE4EB",
                        color: "#DEE4EB",
                        width: "100%"
                    }
                }]
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(MuiPopup, {
        id: 'discard-document-popup',
        variant: "h1",
        openPopup: openPopUp,
        onClose: handleCancelClick,
        closeIcon: true,
        subTitleVariant: "h4",
        subTitleStyle: {
            marginTop: "10px",
            color: "#8593A3"
        },
        backdropEnable: true,
        padding: "15px 0px 0px 15px",
        containerStyle: {
            width: lgMode ? '400px' : 'calc(90vw)',
            paddingTop: 0,
            paddingX: "16px"
        }
    }, /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: formData
    })));
};
